import React, { useEffect, useState } from "react";
import "./ShutterIntro.css";

function ShutterIntro({
  logoSrc = "/assets/brand/brand-title.png",
  alt = "Take 3",
  enterMs = 700, // animate in
  hold = 2200, // stay visible
  exitMs = 700, // animate out
  onComplete = () => {},
}) {
  const [stage, setStage] = useState("enter"); // enter | hold | exit

  useEffect(() => {
    const t1 = setTimeout(() => setStage("hold"), enterMs);
    const t2 = setTimeout(() => setStage("exit"), enterMs + hold);
    const t3 = setTimeout(() => onComplete(), enterMs + hold + exitMs);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [enterMs, hold, exitMs, onComplete]);

  return (
    <div className={`Intro Intro--${stage}`}>
      <img className="Intro__logo" src={logoSrc} alt={alt} />
    </div>
  );
}

export default ShutterIntro;
